import { RootState } from '../../../reducers'
import { openBotIdSelector } from '../../../store/app/selectors'
import { HostingMetadata } from '../../serverBots/types'
import { hostingVersionsApi } from '../hostingVersionsApi'

export function botHostingMetadataSelector(state: RootState): HostingMetadata | undefined {
  return botHostingMetadataQueryStateSelector(state)?.data
}

export function botHostingMetadataQueryStateSelector(state: RootState) {
  const botId = openBotIdSelector(state)

  if (!botId) {
    return undefined
  }

  return hostingVersionsApi.endpoints.getHostingMetadata.select({ botId })(state)
}
